module.exports = __webpack_public_path__ + "static/media/spanish-past-tense-table-3.4d2eeb29.JPG";